import * as React from 'react';

import {useSelector} from '@xstate/react';
import useLabelTranslation from 'src/hooks/useLabelTranslation.ts';

import {selectError} from '../../selectors/commonSelector';
import {useBookingMachine} from '../../hooks/useBookingMachine';

import {ErrorState} from '../../lib/error-state/error-state';
import {TEST_ID} from '../../utils/testId';
import {generateTestId} from '@spaced-out/ui-design-system/lib/utils/qa';


export const BookingAvailabilityError = () => {
  const {t} = useLabelTranslation();
  const {bookingActor} = useBookingMachine();
  const {errorMessage, allowRetry} = useSelector(bookingActor, (state) =>
    selectError(state, t),
  );

  const handleRetry = () => {
    bookingActor.send({type: 'retry'});
  };

  return (
    <ErrorState
      imageVariant="calendar"
      title={errorMessage}
      onRetry={handleRetry}
      allowRetry={allowRetry}
      description={t(
        'We_couldn\'t_load_the_availability_Please_try_again',
        'We couldn\'t load the availability. Please try again',
      )}
      testId={generateTestId({
        base: TEST_ID.BOOKING_FLOW,
        slot: 'availability-error',
      })}
    />
  );
};
